<template>
  <div>

    <Head :title="`${form.domain}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-primary-100 hover:text-primary-200" href="/domains">Domains</Link>
      <span class="text-primary-100 font-medium">/</span>
      {{ form.domain }}
    </h1>
    <div class="tags flex mb-2 lg:w-1/2 flex-wrap">
      <tag v-if="domain.server_name" title="S" :content="domain.server_name"
        :link="'/domains?search=' + domain.server_name" color="bg-primary-300  text-white" />
      <tag v-if="domain.server_ip" title="IP" :content="domain.server_ip" :link="'/domains?search=' + domain.server_ip"
        color="bg-primary-300 text-white" />

      <template v-if="domain.dns">
        <tag v-if="Array.isArray(dnsArray)" v-for="dns in dnsArray" title="NS" :content="dns"
          color="bg-primary-300 text-white" :link="'/domains?search=' + dns" />
        <tag v-else title="NS" :content="domain.dns" :link="'/domains?search=' + domain.dns"
          color="bg-primary-300 text-white" />
      </template>
      <template v-if="domain.mail_ip">
        <tag v-if="Array.isArray(mxArray)" v-for="mx in mxArray" title="MX" :content="mx"
          color="bg-primary-300 text-white" :link="'/domains?search=' + mx" />
        <tag v-else title="MX" :content="domain.mail_ip" :link="'/domains?search=' + domain.mail_ip"
          color="bg-primary-300 text-white" />
      </template>
    </div>
    <trashed-message v-if="domain.deleted_at" class="mb-6" @restore="restore"> This domain has been deleted.
    </trashed-message>
    <div class="max-w-full overflow-hidden">
      <form @submit.prevent="update" class="flex flex-wrap items-start">
        <div class="flex flex-wrap max-w-3xl -mb-8 mr-6 p-8 bg-white rounded-md shadow">
          <text-input v-model="form.domain" :error="form.errors.domain" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name der Domain" />
          <select-input v-model="form.customer_id" :error="form.errors.customer_id" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Kunde">
            <option :value="null" />
            <option v-for="customer in customers" :key="customer.id" :value="customer.id">{{ customer.name }}</option>
          </select-input>

          <div class="datepicker-wrap pb-8 pr-6 w-full lg:w-1/2">
            <label class="form-label">Bestellt am:</label>
            <vue-date-picker timezone="UTC" :exact-match="true" :start-time="startTime"
              input-class-name="dp-custom-input" v-model="form.ordered_at" :format="'dd.MM.yy'" locale="de"
              :enable-time-picker="false" cancelText="abbrechen" selectText="auswählen"></vue-date-picker>
          </div>

          <text-input v-model="form.end" :error="form.errors.end" class="pb-8 pr-6 w-full lg:w-1/2" label="Endung" />

          <textarea-input v-model="form.comment" :error="form.errors.comment" class="pb-8 pr-6 w-full lg:w-full"
            label="Bemerkung" />

          <text-input v-model="form.package" :error="form.errors.package" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Paket" />
          <text-input v-model="form.server_ip" :error="form.errors.server_ip" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Server IP" />

          <text-input v-model="form.dns" :error="form.errors.dns" class="pb-8 pr-6 w-full lg:w-1/2" label="DNS" />
          <text-input v-model="form.registrar" :error="form.errors.registrar" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Registrar" />

          <text-input v-model="form.mail_ip" :error="form.errors.mail_ip" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Mail IP" />
          <text-input disabled v-model="form.server_name" :error="form.errors.server_name"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Servername" />


        </div>

        <div class="flex flex-wrap w-full lg:max-w-sm p-8 bg-white rounded-md shadow">
          <div class="checkbox-wrap pr-6 w-full">
            <div v-if="form.active" class="flex items-center w-full rounded-md bg-green-500 p-2 text-white">
              <icon name="active" class="flex-shrink-0 mr-2 w-5 h-5 fill-white inline text" />
              Domain ist aktiv

            </div>
            <div v-else class="flex items-center w-full rounded-md bg-red-500 p-2 text-white">
              <icon name="inactive" class="flex-shrink-0 mr-2 w-5 h-5 fill-white inline" />
              Domain ist inaktiv

            </div>
            <div>
              <checkbox-input v-model="form.active" :error="form.errors.active" label="" />
            </div>
          </div>
          <hr class="w-full bg-gray-200 h-px mt-6 mb-6">
          <div class="checkbox-wrap pr-6 w-full lg:w-1/2">
            <checkbox-input v-model="form.flaged" :error="form.errors.active" label="Gekündigt" />
            {{ form.flaged }}
          </div>
          <div class="checkbox-wrap pr-6 w-full lg:w-1/2">
            <checkbox-input v-model="form.charged" :error="form.errors.active" label="Wird abgerechnet" />
          </div>
          <hr class="w-full bg-gray-200 h-px mt-6 mb-6">
          <div v-if="form.flaged" class="datepicker-wrap pb-8 pr-6 w-full">
            <label class="form-label">Gekündigt zum:</label>
            <vue-date-picker timezone="UTC" :exact-match="true" :start-time="startTime"
              input-class-name="dp-custom-input" v-model="form.cancel_date" :format="'dd.MM.yy'" locale="de"
              :enable-time-picker="false" cancelText="abbrechen" selectText="auswählen"></vue-date-picker>
          </div>
          <div v-if="form.charged" class="datepicker-wrap pb-8 pr-6 w-full lg:w-1/2">
            <label class="form-label">Berechnet am:</label>
            <vue-date-picker timezone="UTC" :exact-match="true" :start-time="startTime" :enable-time-picker="false"
              input-class-name="dp-custom-input" v-model="form.charged_till" :format="'dd.MM.yy'" locale="de"
              cancelText="abbrechen" selectText="auswählen"></vue-date-picker>
          </div>
          <text-input v-if="form.charged" v-model="form.amount_net" :error="form.errors.amount_net"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Betrag/NETTO" />
        </div>

        <div class="w-full max-w-3xl flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!domain.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
            @click="destroy">Domain löschen</button>

          <div class="ml-auto flex">
            <a :href="`/tools/refresh-dns?id=${form.id}`" class="btn-primary-100 mr-2">DNS-Info erneuern</a>

            <loading-button :loading="form.processing" class="btn-primary-100"
              type="submit">Speichern</loading-button>
          </div>

        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Tag from '@/Shared/Tag'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import CheckboxInput from '@/Shared/CheckboxInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { Inertia } from '@inertiajs/inertia'
import { onUnmounted } from 'vue'
import { ref } from 'vue';
import Icon from '@/Shared/Icon'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    TrashedMessage,
    CheckboxInput,
    VueDatePicker,
    Tag,
    Icon
  },
  layout: Layout,
  props: {
    domain: Object,
    customers: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.domain.id,
        domain: this.domain.domain,
        active: this.domain.active,
        due_date: this.domain.due_date,
        charged: this.domain.charged,
        end: this.domain.end,
        ordered_at: this.domain.ordered_at,
        charged_till: this.domain.charged_till,
        comment: this.domain.comment,
        package: this.domain.package,
        dns: this.domain.dns,
        registrar: this.domain.registrar,
        server_ip: this.domain.server_ip,
        mail_ip: this.domain.mail_ip,
        server_name: this.domain.server_name,
        customer_id: this.domain.customer_id,
        flaged: this.domain.flaged,
        cancel_date: this.domain.cancel_date,
        amount_net: this.domain.amount_net
      }),
    }
  },
  setup(props) {

    const startTime = { hours: 0, minutes: 0 };

    let dnsArray = [];
    let mxArray = [];

    if (isJsonString(props.domain.dns)) {
      dnsArray = JSON.parse(props.domain.dns);
    } else {
      dnsArray = props.domain.dns;
    }

    if (isJsonString(props.domain.mail_ip)) {
      mxArray = JSON.parse(props.domain.mail_ip);
    } else {
      mxArray = props.domain.mail_ip;
    }

    console.log(props.domain);

    function isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    return { dnsArray, mxArray, startTime }
  },
  mounted() {
    onUnmounted(
      Inertia.on('before', (event) => {
        if (this.form.isDirty) {
          if (!confirm('Deine Änderungen wurden noch nicht gespeichert. Seite wirklich verlassen?')) {
            event.preventDefault()
          }
        }
      })
    )
  },
  beforeUnmount() {
    //window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    beforeWindowUnload(event) {
      if (this.form.isDirty) {
        event.preventDefault()
        event.returnValue = ''
      }
    },
    handleBeforeRouteLeave(event) {
      if (this.form.isDirty && !confirm('You have unsaved changes. Are you sure you want to leave?')) {
        event.preventDefault()
      }
    },
    update() {
      this.form.isDirty = false
      this.form.put(`/domains/${this.domain.id}`)
    },
    updateDNS() {
      this.$inertia.get(`/tools/refresh-dns`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this domain?')) {
        this.$inertia.delete(`/domains/${this.domain.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this domain?')) {
        this.$inertia.put(`/domains/${this.domain.id}/restore`)
      }
    },
  },
}
</script>
